document.querySelectorAll('.pc-form').forEach(form => {
	const action = form.getAttribute('action')
	const method = form.getAttribute('method')
	form.addEventListener('submit', async e => {
		e.preventDefault()
		const statusOutput = form.querySelector('.status')
		const submitButton = form.querySelector('button')
		const submitButtonText = submitButton.querySelector('span')
		submitButton.disabled = true
		submitButtonText.innerText = 'Submitting...'
		const body = new FormData(form)
		const res = await fetch(action, {
			method,
			headers: {
				Accept: 'application/json',
			},
			body,
		})
		const { success } = await res.json()
		if (success) {
			submitButtonText.innerText = 'Submitted'
			statusOutput.classList.add('success')
			submitButton.disabled = true
			statusOutput.value =
				'Thank you for your message! We will be in touch soon.'
		} else {
			submitButtonText.innerText = 'Submit'
			submitButton.disabled = false
			statusOutput.classList.add('error')
			statusOutput.value =
				'Sorry, there was a problem sending your message. Please try again, or contact us at (509) 413-1152.'
		}
	})
})
